import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  p: (p) => p.spacing(1, 2),
};
